export default __webpack_public_path__ + "static/media/iq.59023b94.jpg";